export default __webpack_public_path__ + "static/media/sec4.85f6a360.png";